import { useTranslation } from "react-i18next";
import { InfoText } from "../../core/components/texts/InfoText";
import { useWidgetConfig } from "../../widget/WidgetContext";
import { AppointmentScreenWrapper } from "../onboarding/AppointmentScreenWrapper";
import { useNavigateToReturnUrl } from "./utils/useNavigateToReturnUrl";

export const AppointmentSuccessScreen = () => {
  const { t } = useTranslation();
  const { onClose: closeWidget } = useWidgetConfig();
  const { appointmentReturnUrl, navigateToReturnUrl, returnButtonText } =
    useNavigateToReturnUrl();

  const openWebsite = () => {
    if (closeWidget) {
      closeWidget();
    } else if (appointmentReturnUrl) {
      navigateToReturnUrl();
    } else {
      window.close();
    }
  };

  return (
    <AppointmentScreenWrapper
      onNext={openWebsite}
      nextButtonText={appointmentReturnUrl ? returnButtonText : undefined}
      hideNextButton={!appointmentReturnUrl && !closeWidget}
      hideBackButton>
      <InfoText
        headline={t("APPOINTMENT_SUCCESS_HEADLINE")}
        text={[
          t("APPOINTMENT_SUCCESS_DESCRIPTION"),
          ...(!appointmentReturnUrl ? [t("CLOSE_WINDOW_TEXT")] : []),
        ]}
      />
    </AppointmentScreenWrapper>
  );
};
